import * as React from 'react';
import { TextInput } from 'sos-common/js/components/FormControls/TextInput';

export class MultipleTextInputs extends React.Component<any, any> {
    render() {
        return (<>
            {this.props.inputs.map((x, i) => (
                <div key={`TextInput-${i}`} className='col-sm-6 m-b-2'>
                    <TextInput
                        key={x.key}
                        errorMessage={x.errorMessage}
                        onChange={value => this.props.onChange(value, Number(this.props.id))}
                        label={x.label}
                        value={x.value}
                        fieldName={x.fieldName}
                        maxLength={160}
                        isRequired={x.isRequired}
                    />
                </div>
            ))}
        </>
        )
    }
}